/*@ngInject*/
const SectionTemplateBrowserActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.proposal.SectionTemplate:null'
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('sectionTemplateBrowserActionRepository', SectionTemplateBrowserActionRepository);
